import { CountryCode } from 'libphonenumber-js';
import { Language } from '../enums';
import { TranslatedField } from '../translated-field.model';

export interface CountryInfo {
        name: string;
        dialCode: string;
        code: CountryCode;
        names: TranslatedField[]
}

export const allCountryCodes: CountryInfo[] =[
    {
        name:'Afghanistan',
        dialCode:'+93',
        code:'AF',
        names:[
            {
                lang: Language.NL,
                value:'Afghanistan'
            },
            {
                lang: Language.FR,
                value:'Afghanistan'
            },
            {
                lang: Language.DE,
                value:'Afghanistan'
            }
        ]
    },
    {
        name:'Aland Islands',
        dialCode:'+358',
        code:'AX',
        names:[
            {
                lang: Language.NL,
                value:'Åland'
            },
            {
                lang: Language.FR,
                value:'Åland'
            },
            {
                lang: Language.DE,
                value:'Åland'
            }
        ]
    },
    {
        name:'Albania',
        dialCode:'+355',
        code:'AL',
        names:[
            {
                lang: Language.NL,
                value:'Albanië'
            },
            {
                lang: Language.FR,
                value:'Albanie'
            },
            {
                lang: Language.DE,
                value:'Albanien'
            }
        ]
    },
    {
        name:'Algeria',
        dialCode:'+213',
        code:'DZ',
        names:[
            {
                lang: Language.NL,
                value:'Algerije'
            },
            {
                lang: Language.FR,
                value:'Algérie'
            },
            {
                lang: Language.DE,
                value:'Algerien'
            }
        ]
    },
    {
        name:'AmericanSamoa',
        dialCode:'+1684',
        code:'AS',
        names:[
            {
                lang: Language.NL,
                value:'Amerik.Samoaeilanden'
            },
            {
                lang: Language.FR,
                value:'Samoa américaines'
            },
            {
                lang: Language.DE,
                value:'Amerik.Samoainseln'
            }
        ]
    },
    {
        name:'Andorra',
        dialCode:'+376',
        code:'AD',
        names:[
            {
                lang: Language.NL,
                value:'Andorra'
            },
            {
                lang: Language.FR,
                value:'Andorre'
            },
            {
                lang: Language.DE,
                value:'Andorra'
            }
        ]
    },
    {
        name:'Angola',
        dialCode:'+244',
        code:'AO',
        names:[
            {
                lang: Language.NL,
                value:'Angola'
            },
            {
                lang: Language.FR,
                value:'Angola'
            },
            {
                lang: Language.DE,
                value:'Angola'
            }
        ]
    },
    {
        name:'Anguilla',
        dialCode:'+1264',
        code:'AI',
        names:[
            {
                lang: Language.NL,
                value:'Anguilla'
            },
            {
                lang: Language.FR,
                value:'Anguilla'
            },
            {
                lang: Language.DE,
                value:'Anguilla'
            }
        ]
    },
    {
        name:'Antigua and Barbuda',
        dialCode:'+1268',
        code:'AG',
        names:[
            {
                lang: Language.NL,
                value:'Antigua en Barbuda'
            },
            {
                lang: Language.FR,
                value:'Antigua-et-Barbuda'
            },
            {
                lang: Language.DE,
                value:'Antigua und Barbuda'
            }
        ]
    },
    {
        name:'Argentina',
        dialCode:'+54',
        code:'AR',
        names:[
            {
                lang: Language.NL,
                value:'Argentinië'
            },
            {
                lang: Language.FR,
                value:'Argentine'
            },
            {
                lang: Language.DE,
                value:'Argentinien'
            }
        ]
    },
    {
        name:'Armenia',
        dialCode:'+374',
        code:'AM',
        names:[
            {
                lang: Language.NL,
                value:'Armenië'
            },
            {
                lang: Language.FR,
                value:'Arménie'
            },
            {
                lang: Language.DE,
                value:'Armenien'
            }
        ]
    },
    {
        name:'Aruba',
        dialCode:'+297',
        code:'AW',
        names:[
            {
                lang: Language.NL,
                value:'Aruba'
            },
            {
                lang: Language.FR,
                value:'Aruba'
            },
            {
                lang: Language.DE,
                value:'Aruba'
            }
        ]
    },
    {
        name:'Australia',
        dialCode:'+61',
        code:'AU',
        names:[
            {
                lang: Language.NL,
                value:'Australië'
            },
            {
                lang: Language.FR,
                value:'Australie'
            },
            {
                lang: Language.DE,
                value:'Australien'
            }
        ]
    },
    {
        name:'Austria',
        dialCode:'+43',
        code:'AT',
        names:[
            {
                lang: Language.NL,
                value:'Oostenrijk'
            },
            {
                lang: Language.FR,
                value:'Autriche'
            },
            {
                lang: Language.DE,
                value:'Oesterreich'
            }
        ]
    },
    {
        name:'Azerbaijan',
        dialCode:'+994',
        code:'AZ',
        names:[
            {
                lang: Language.NL,
                value:'Azerbeidzjan'
            },
            {
                lang: Language.FR,
                value:'Azerbaïdjan'
            },
            {
                lang: Language.DE,
                value:'Azerbaidschan'
            }
        ]
    },
    {
        name:'Bahamas',
        dialCode:'+1242',
        code:'BS',
        names:[
            {
                lang: Language.NL,
                value:'Bahamas'
            },
            {
                lang: Language.FR,
                value:'Bahamas'
            },
            {
                lang: Language.DE,
                value:'Bahamas'
            }
        ]
    },
    {
        name:'Bahrain',
        dialCode:'+973',
        code:'BH',
        names:[
            {
                lang: Language.NL,
                value:'Bahrein'
            },
            {
                lang: Language.FR,
                value:'Bahreïn'
            },
            {
                lang: Language.DE,
                value:'Bahrain'
            }
        ]
    },
    {
        name:'Bangladesh',
        dialCode:'+880',
        code:'BD',
        names:[
            {
                lang: Language.NL,
                value:'Bangladesh'
            },
            {
                lang: Language.FR,
                value:'Bangladesh'
            },
            {
                lang: Language.DE,
                value:'Bangla-Desh'
            }
        ]
    },
    {
        name:'Barbados',
        dialCode:'+1246',
        code:'BB',
        names:[
            {
                lang: Language.NL,
                value:'Barbados'
            },
            {
                lang: Language.FR,
                value:'Barbade'
            },
            {
                lang: Language.DE,
                value:'Barbados'
            }
        ]
    },
    {
        name:'Belarus',
        dialCode:'+375',
        code:'BY',
        names:[
            {
                lang: Language.NL,
                value:'Belarus'
            },
            {
                lang: Language.FR,
                value:'Biélorussie'
            },
            {
                lang: Language.DE,
                value:'Weissrussland'
            }
        ]
    },
    {
        name:'Belgium',
        dialCode:'+32',
        code:'BE',
        names:[
            {
                lang: Language.NL,
                value:'België'
            },
            {
                lang: Language.FR,
                value:'Belgique'
            },
            {
                lang: Language.DE,
                value:'Belgien'
            }
        ]
    },
    {
        name:'Belize',
        dialCode:'+501',
        code:'BZ',
        names:[
            {
                lang: Language.NL,
                value:'Belize'
            },
            {
                lang: Language.FR,
                value:'Belize'
            },
            {
                lang: Language.DE,
                value:'Belize'
            }
        ]
    },
    {
        name:'Benin',
        dialCode:'+229',
        code:'BJ',
        names:[
            {
                lang: Language.NL,
                value:'Benin'
            },
            {
                lang: Language.FR,
                value:'Bénin'
            },
            {
                lang: Language.DE,
                value:'Benin'
            }
        ]
    },
    {
        name:'Bermuda',
        dialCode:'+1441',
        code:'BM',
        names:[
            {
                lang: Language.NL,
                value:'Bermuda\'s'
            },
            {
                lang: Language.FR,
                value:'Bermudes'
            },
            {
                lang: Language.DE,
                value:'Bermudas'
            }
        ]
    },
    {
        name:'Bhutan',
        dialCode:'+975',
        code:'BT',
        names:[
            {
                lang: Language.NL,
                value:'Bhutan'
            },
            {
                lang: Language.FR,
                value:'Bhoutan'
            },
            {
                lang: Language.DE,
                value:'Bhutan'
            }
        ]
    },
    {
        name:'Bolivia, Plurinational State of',
        dialCode:'+591',
        code:'BO',
        names:[
            {
                lang: Language.NL,
                value:'Bolivië'
            },
            {
                lang: Language.FR,
                value:'Bolivie'
            },
            {
                lang: Language.DE,
                value:'Bolivien'
            }
        ]
    },
    {
        name:'Bosnia and Herzegovina',
        dialCode:'+387',
        code:'BA',
        names:[
            {
                lang: Language.NL,
                value:'Bosnië-Herzegovina'
            },
            {
                lang: Language.FR,
                value:'Bosnie-Herzégovine'
            },
            {
                lang: Language.DE,
                value:'Bosnien-Herczegowina'
            }
        ]
    },
    {
        name:'Botswana',
        dialCode:'+267',
        code:'BW',
        names:[
            {
                lang: Language.NL,
                value:'Botswana'
            },
            {
                lang: Language.FR,
                value:'Botswana'
            },
            {
                lang: Language.DE,
                value:'Botswana'
            }
        ]
    },
    {
        name:'Brazil',
        dialCode:'+55',
        code:'BR',
        names:[
            {
                lang: Language.NL,
                value:'Brazilië'
            },
            {
                lang: Language.FR,
                value:'Brésil'
            },
            {
                lang: Language.DE,
                value:'Brasilien'
            }
        ]
    },
    {
        name:'British Indian Ocean Territory',
        dialCode:'+246',
        code:'IO',
        names:[
            {
                lang: Language.NL,
                value:'Brits Indische Oceaanterritorium'
            },
            {
                lang: Language.FR,
                value:'Territoire britannique de l\'océan Indien'
            },
            {
                lang: Language.DE,
                value:'Britisches Territorium im Indischen Ozean'
            }
        ]
    },
    {
        name:'Brunei Darussalam',
        dialCode:'+673',
        code:'BN',
        names:[
            {
                lang: Language.NL,
                value:'Brunei'
            },
            {
                lang: Language.FR,
                value:'Brunei'
            },
            {
                lang: Language.DE,
                value:'Brunei'
            }
        ]
    },
    {
        name:'Bulgaria',
        dialCode:'+359',
        code:'BG',
        names:[
            {
                lang: Language.NL,
                value:'Bulgarije'
            },
            {
                lang: Language.FR,
                value:'Bulgarie'
            },
            {
                lang: Language.DE,
                value:'Bulgarien'
            }
        ]
    },
    {
        name:'Burkina Faso',
        dialCode:'+226',
        code:'BF',
        names:[
            {
                lang: Language.NL,
                value:'Burkina Faso'
            },
            {
                lang: Language.FR,
                value:'Burkina Faso'
            },
            {
                lang: Language.DE,
                value:'Burkina Faso'
            }
        ]
    },
    {
        name:'Burundi',
        dialCode:'+257',
        code:'BI',
        names:[
            {
                lang: Language.NL,
                value:'Burundi'
            },
            {
                lang: Language.FR,
                value:'Burundi'
            },
            {
                lang: Language.DE,
                value:'Burundi'
            }
        ]
    },
    {
        name:'Cambodia',
        dialCode:'+855',
        code:'KH',
        names:[
            {
                lang: Language.NL,
                value:'Cambodja'
            },
            {
                lang: Language.FR,
                value:'Cambodge'
            },
            {
                lang: Language.DE,
                value:'Kambodscha'
            }
        ]
    },
    {
        name:'Cameroon',
        dialCode:'+237',
        code:'CM',
        names:[
            {
                lang: Language.NL,
                value:'Kameroen'
            },
            {
                lang: Language.FR,
                value:'Cameroun'
            },
            {
                lang: Language.DE,
                value:'Kamerun'
            }
        ]
    },
    {
        name:'Canada',
        dialCode:'+1',
        code:'CA',
        names:[
            {
                lang: Language.NL,
                value:'Canada'
            },
            {
                lang: Language.FR,
                value:'Canada'
            },
            {
                lang: Language.DE,
                value:'Kanada'
            }
        ]
    },
    {
        name:'Cape Verde',
        dialCode:'+238',
        code:'CV',
        names:[
            {
                lang: Language.NL,
                value:'Kaapverdische'
            },
            {
                lang: Language.FR,
                value:'Cap Vert'
            },
            {
                lang: Language.DE,
                value:'Kapverdische'
            }
        ]
    },
    {
        name:'Cayman Islands',
        dialCode:'+ 345',
        code:'KY',
        names:[
            {
                lang: Language.NL,
                value:'Caïmanes'
            },
            {
                lang: Language.FR,
                value:'Caïmanes'
            },
            {
                lang: Language.DE,
                value:'Kaiman'
            }
        ]
    },
    {
        name:'Central African Republic',
        dialCode:'+236',
        code:'CF',
        names:[
            {
                lang: Language.NL,
                value:'Centraalafrikaanse Republiek'
            },
            {
                lang: Language.FR,
                value:'République Centrafricaine'
            },
            {
                lang: Language.DE,
                value:'Zentralafrikanische Republik'
            }
        ]
    },
    {
        name:'Chad',
        dialCode:'+235',
        code:'TD',
        names:[
            {
                lang: Language.NL,
                value:'Tsjaad'
            },
            {
                lang: Language.FR,
                value:'Tchad'
            },
            {
                lang: Language.DE,
                value:'Tschad'
            }
        ]
    },
    {
        name:'Chile',
        dialCode:'+56',
        code:'CL',
        names:[
            {
                lang: Language.NL,
                value:'Chili'
            },
            {
                lang: Language.FR,
                value:'Chili'
            },
            {
                lang: Language.DE,
                value:'Chile'
            }
        ]
    },
    {
        name:'China',
        dialCode:'+86',
        code:'CN',
        names:[
            {
                lang: Language.NL,
                value:'China'
            },
            {
                lang: Language.FR,
                value:'Chine'
            },
            {
                lang: Language.DE,
                value:'China'
            }
        ]
    },
    {
        name:'Christmas Island',
        dialCode:'+61',
        code:'CX',
        names: [
            {
                lang:  Language.NL,
                value: 'Christmaseiland'
            },
            {
                lang:  Language.FR,
                value: 'Île Christmas'
            },
            {
                lang:  Language.DE,
                value: 'Weihnachtsinsel'
            }
        ]
    },
    {
        name:'Cocos (Keeling) Islands',
        dialCode:'+61',
        code:'CC',
        names: [
            {
                lang:  Language.NL,
                value: 'Cocoseilanden'
            },
            {
                lang:  Language.FR,
                value: 'Îles Cocos'
            },
            {
                lang:  Language.DE,
                value: 'Kokosinseln'
            }
        ]
    },
    {
        name:'Colombia',
        dialCode:'+57',
        code:'CO',
        names:[
            {
                lang: Language.NL,
                value:'Colombia'
            },
            {
                lang: Language.FR,
                value:'Colombie'
            },
            {
                lang: Language.DE,
                value:'Kolumbien'
            }
        ]
    },
    {
        name:'Comoros',
        dialCode:'+269',
        code:'KM',
        names:[
            {
                lang: Language.NL,
                value:'Comoren'
            },
            {
                lang: Language.FR,
                value:'Comores'
            },
            {
                lang: Language.DE,
                value:'Archipel'
            }
        ]
    },
    {
        name:'Congo',
        dialCode:'+242',
        code:'CG',
        names:[
            {
                lang: Language.NL,
                value:'Congo (Dem. Rep.)'
            },
            {
                lang: Language.FR,
                value:'Congo (Rép. dém.)'
            },
            {
                lang: Language.DE,
                value:'Kongo (Dem. Rep.)'
            }
        ]
    },
    {
        name:'Congo, The Democratic Republic of the Congo',
        dialCode:'+243',
        code:'CD',
        names:[
            {
                lang: Language.NL,
                value:'Congo (Dem. Rep.)'
            },
            {
                lang: Language.FR,
                value:'Congo (Rép. dém.)'
            },
            {
                lang: Language.DE,
                value:'Kongo (Dem. Rep.)'
            }
        ]
    },
    {
        name:'Cook Islands',
        dialCode:'+682',
        code:'CK',
        names:[
            {
                lang: Language.NL,
                value:'Cook'
            },
            {
                lang: Language.FR,
                value:'Cook'
            },
            {
                lang: Language.DE,
                value:'Cookinseln'
            }
        ]
    },
    {
        name:'Costa Rica',
        dialCode:'+506',
        code:'CR',
        names:[
            {
                lang: Language.NL,
                value:'Costa Rica'
            },
            {
                lang: Language.FR,
                value:'Costa Rica'
            },
            {
                lang: Language.DE,
                value:'Costa Rica'
            }
        ]
    },
    {
        name:'Cote d\'Ivoire',
        dialCode:'+225',
        code:'CI',
        names:[
            {
                lang: Language.NL,
                value:'Ivoorkust'
            },
            {
                lang: Language.FR,
                value:'Côte d\'Ivoire'
            },
            {
                lang: Language.DE,
                value:'Elfenbeinküste'
            }
        ]
    },
    {
        name:'Croatia',
        dialCode:'+385',
        code:'HR',
        names:[
            {
                lang: Language.NL,
                value:'Croatië'
            },
            {
                lang: Language.FR,
                value:'Kroatië'
            },
            {
                lang: Language.DE,
                value:'Kroatien'
            }
        ]
    },
    {
        name:'Cuba',
        dialCode:'+53',
        code:'CU',
        names:[
            {
                lang: Language.NL,
                value:'Cuba'
            },
            {
                lang: Language.FR,
                value:'Cuba'
            },
            {
                lang: Language.DE,
                value:'Kuba'
            }
        ]
    },
    {
        name:'Cyprus',
        dialCode:'+357',
        code:'CY',
        names:[
            {
                lang: Language.NL,
                value:'Cyprus'
            },
            {
                lang: Language.FR,
                value:'Chypre'
            },
            {
                lang: Language.DE,
                value:'Zypern'
            }
        ]
    },
    {
        name:'Czech Republic',
        dialCode:'+420',
        code:'CZ',
        names:[
            {
                lang: Language.NL,
                value:'Tsjechische Republiek'
            },
            {
                lang: Language.FR,
                value:'République Tchèque'
            },
            {
                lang: Language.DE,
                value:'Tschechische Republik'
            }
        ]
    },
    {
        name:'Denmark',
        dialCode:'+45',
        code:'DK',
        names:[
            {
                lang: Language.NL,
                value:'Denemarken'
            },
            {
                lang: Language.FR,
                value:'Danemark'
            },
            {
                lang: Language.DE,
                value:'Dänemark'
            }
        ]
    },
    {
        name:'Djibouti',
        dialCode:'+253',
        code:'DJ',
        names:[
            {
                lang: Language.NL,
                value:'Djibouti'
            },
            {
                lang: Language.FR,
                value:'Djibouti'
            },
            {
                lang: Language.DE,
                value:'Djibouti'
            }
        ]
    },
    {
        name:'Dominica',
        dialCode:'+1767',
        code:'DM',
        names:[
            {
                lang: Language.NL,
                value:'Dominica (Republiek)'
            },
            {
                lang: Language.FR,
                value:'Dominique (République)'
            },
            {
                lang: Language.DE,
                value:'Dominica (Republik)'
            }
        ]
    },
    {
        name:'Dominican Republic',
        dialCode:'+1849',
        code:'DO',
        names:[
            {
                lang: Language.NL,
                value:'Dominikaanse (Republiek)'
            },
            {
                lang: Language.FR,
                value:'Dominicaine'
            },
            {
                lang: Language.DE,
                value:'Dominikanische Republik'
            }
        ]
    },
    {
        name:'Ecuador',
        dialCode:'+593',
        code:'EC',
        names:[
            {
                lang: Language.NL,
                value:'Ecuador'
            },
            {
                lang: Language.FR,
                value:'Equateur'
            },
            {
                lang: Language.DE,
                value:'Ekuador'
            }
        ]
    },
    {
        name:'Egypt',
        dialCode:'+20',
        code:'EG',
        names:[
            {
                lang: Language.NL,
                value:'Egypte'
            },
            {
                lang: Language.FR,
                value:'Egypte'
            },
            {
                lang: Language.DE,
                value:'Ägypten'
            }
        ]
    },
    {
        name:'El Salvador',
        dialCode:'+503',
        code:'SV',
        names:[
            {
                lang: Language.NL,
                value:'El Salvador'
            },
            {
                lang: Language.FR,
                value:'El Salvador'
            },
            {
                lang: Language.DE,
                value:'El Salvador'
            }
        ]
    },
    {
        name:'Equatorial Guinea',
        dialCode:'+240',
        code:'GQ',
        names:[
            {
                lang: Language.NL,
                value:'Equatoriaal-Guinea'
            },
            {
                lang: Language.FR,
                value:'Guinée équatoriale'
            },
            {
                lang: Language.DE,
                value:'Äquatoriales Guinea'
            }
        ]
    },
    {
        name:'Eritrea',
        dialCode:'+291',
        code:'ER',
        names:[
            {
                lang: Language.NL,
                value:'Erithrea'
            },
            {
                lang: Language.FR,
                value:'Erythrée'
            },
            {
                lang: Language.DE,
                value:'Erythräen'
            }
        ]
    },
    {
        name:'Estonia',
        dialCode:'+372',
        code:'EE',
        names:[
            {
                lang: Language.NL,
                value:'Estland'
            },
            {
                lang: Language.FR,
                value:'Estonie'
            },
            {
                lang: Language.DE,
                value:'Estland'
            }
        ]
    },
    {
        name:'Ethiopia',
        dialCode:'+251',
        code:'ET',
        names:[
            {
                lang: Language.NL,
                value:'Ethiopië'
            },
            {
                lang: Language.FR,
                value:'Ethiopie'
            },
            {
                lang: Language.DE,
                value:'Äthiopien'
            }
        ]
    },
    {
        name:'Falkland Islands (Malvinas)',
        dialCode:'+500',
        code:'FK',
        names:[
            {
                lang: Language.NL,
                value:'Falkland Eilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Falkland'
            },
            {
                lang: Language.DE,
                value:'Falklandinseln'
            }
        ]
    },
    {
        name:'Faroe Islands',
        dialCode:'+298',
        code:'FO',
        names:[
            {
                lang: Language.NL,
                value:'Faeröer'
            },
            {
                lang: Language.FR,
                value:'Îles Féroé'
            },
            {
                lang: Language.DE,
                value:'Färöer'
            }
        ]
    },
    {
        name:'Fiji',
        dialCode:'+679',
        code:'FJ',
        names:[
            {
                lang: Language.NL,
                value:'Fiji'
            },
            {
                lang: Language.FR,
                value:'Fidji'
            },
            {
                lang: Language.DE,
                value:'Fidschi'
            }
        ]
    },
    {
        name:'Finland',
        dialCode:'+358',
        code:'FI',
        names:[
            {
                lang: Language.NL,
                value:'Finland'
            },
            {
                lang: Language.FR,
                value:'Finlande'
            },
            {
                lang: Language.DE,
                value:'Finnland'
            }
        ]
    },
    {
        name:'France',
        dialCode:'+33',
        code:'FR',
        names:[
            {
                lang: Language.NL,
                value:'Frankrijk'
            },
            {
                lang: Language.FR,
                value:'France'
            },
            {
                lang: Language.DE,
                value:'Frankreich'
            }
        ]
    },
    {
        name:'French Guiana',
        dialCode:'+594',
        code:'GF',
        names:[
            {
                lang: Language.NL,
                value:'Frans Guyana'
            },
            {
                lang: Language.FR,
                value:'Guyane Française'
            },
            {
                lang: Language.DE,
                value:'Französisch-Guyana'
            }
        ]
    },
    {
        name:'French Polynesia',
        dialCode:'+689',
        code:'PF',
        names:[
            {
                lang: Language.NL,
                value:'Polynesië'
            },
            {
                lang: Language.FR,
                value:'Polynésie'
            },
            {
                lang: Language.DE,
                value:'Polynesien'
            }
        ]
    },
    {
        name:'Gabon',
        dialCode:'+241',
        code:'GA',
        names:[
            {
                lang: Language.NL,
                value:'Gabon'
            },
            {
                lang: Language.FR,
                value:'Gabon'
            },
            {
                lang: Language.DE,
                value:'Gabun'
            }
        ]
    },
    {
        name:'Gambia',
        dialCode:'+220',
        code:'GM',
        names:[
            {
                lang: Language.NL,
                value:'Gambia'
            },
            {
                lang: Language.FR,
                value:'Gambie'
            },
            {
                lang: Language.DE,
                value:'Gambia'
            }
        ]
    },
    {
        name:'Georgia',
        dialCode:'+995',
        code:'GE',
        names:[
            {
                lang: Language.NL,
                value:'Georgië'
            },
            {
                lang: Language.FR,
                value:'Géorgie'
            },
            {
                lang: Language.DE,
                value:'Georgien'
            }
        ]
    },
    {
        name:'Germany',
        dialCode:'+49',
        code:'DE',
        names:[
            {
                lang: Language.NL,
                value:'Duitsland'
            },
            {
                lang: Language.FR,
                value:'Allemagne'
            },
            {
                lang: Language.DE,
                value:'Deutschland'
            }
        ]
    },
    {
        name:'Ghana',
        dialCode:'+233',
        code:'GH',
        names:[
            {
                lang: Language.NL,
                value:'Ghana'
            },
            {
                lang: Language.FR,
                value:'Ghana'
            },
            {
                lang: Language.DE,
                value:'Ghana'
            }
        ]
    },
    {
        name:'Gibraltar',
        dialCode:'+350',
        code:'GI',
        names:[
            {
                lang: Language.NL,
                value:'Gibraltar'
            },
            {
                lang: Language.FR,
                value:'Gibraltar'
            },
            {
                lang: Language.DE,
                value:'Gibraltar'
            }
        ]
    },
    {
        name:'Greece',
        dialCode:'+30',
        code:'GR',
        names:[
            {
                lang: Language.NL,
                value:'Griekenland'
            },
            {
                lang: Language.FR,
                value:'Grèce'
            },
            {
                lang: Language.DE,
                value:'Griechenland'
            }
        ]
    },
    {
        name:'Greenland',
        dialCode:'+299',
        code:'GL',
        names:[
            {
                lang: Language.NL,
                value:'Groenland'
            },
            {
                lang: Language.FR,
                value:'Groenland'
            },
            {
                lang: Language.DE,
                value:'Grönland'
            }
        ]
    },
    {
        name:'Grenada',
        dialCode:'+1473',
        code:'GD',
        names:[
            {
                lang: Language.NL,
                value:'Grenada'
            },
            {
                lang: Language.FR,
                value:'Grenade'
            },
            {
                lang: Language.DE,
                value:'Grenada'
            }
        ]
    },
    {
        name:'Guadeloupe',
        dialCode:'+590',
        code:'GP',
        names:[
            {
                lang: Language.NL,
                value:'Guadeloupe'
            },
            {
                lang: Language.FR,
                value:'Guadeloupe'
            },
            {
                lang: Language.DE,
                value:'Guadeloupe'
            }
        ]
    },
    {
        name:'Guam',
        dialCode:'+1671',
        code:'GU',
        names:[
            {
                lang: Language.NL,
                value:'Guam'
            },
            {
                lang: Language.FR,
                value:'Guam'
            },
            {
                lang: Language.DE,
                value:'Guam'
            }
        ]
    },
    {
        name:'Guatemala',
        dialCode:'+502',
        code:'GT',
        names:[
            {
                lang: Language.NL,
                value:'Guatemala'
            },
            {
                lang: Language.FR,
                value:'Guatémala'
            },
            {
                lang: Language.DE,
                value:'Guatemala'
            }
        ]
    },
    {
        name:'Guernsey',
        dialCode:'+44',
        code:'GG',
        names:[
            {
                lang: Language.NL,
                value:'Guernsey'
            },
            {
                lang: Language.FR,
                value:'Guernesey'
            },
            {
                lang: Language.DE,
                value:'Guernsey'
            }
        ]
    },
    {
        name:'Guinea',
        dialCode:'+224',
        code:'GN',
        names:[
            {
                lang: Language.NL,
                value:'Guinea'
            },
            {
                lang: Language.FR,
                value:'Guinée'
            },
            {
                lang: Language.DE,
                value:'Guinea'
            }
        ]
    },
    {
        name:'Guinea-Bissau',
        dialCode:'+245',
        code:'GW',
        names:[
            {
                lang: Language.NL,
                value:'Guinee-Bissau'
            },
            {
                lang: Language.FR,
                value:'Guinée-Bissau'
            },
            {
                lang: Language.DE,
                value:'Guinea-Bissau'
            }
        ]
    },
    {
        name:'Guyana',
        dialCode:'+595',
        code:'GY',
        names:[
            {
                lang: Language.NL,
                value:'Guyana'
            },
            {
                lang: Language.FR,
                value:'Guyane'
            },
            {
                lang: Language.DE,
                value:'Guyana'
            }
        ]
    },
    {
        name:'Haiti',
        dialCode:'+509',
        code:'HT',
        names:[
            {
                lang: Language.NL,
                value:'Haïti'
            },
            {
                lang: Language.FR,
                value:'Haïti'
            },
            {
                lang: Language.DE,
                value:'Haiti'
            }
        ]
    },
    {
        name:'Holy See (Vatican City State)',
        dialCode:'+379',
        code:'VA',
        names:[
            {
                lang: Language.NL,
                value:'Heilige Stoel'
            },
            {
                lang: Language.FR,
                value:'Saint-Siège'
            },
            {
                lang: Language.DE,
                value:'Päpstlicher Stuhl'
            }
        ]
    },
    {
        name:'Honduras',
        dialCode:'+504',
        code:'HN',
        names:[
            {
                lang: Language.NL,
                value:'Honduras'
            },
            {
                lang: Language.FR,
                value:'Honduras'
            },
            {
                lang: Language.DE,
                value:'Honduras'
            }
        ]
    },
    {
        name:'Hong Kong',
        dialCode:'+852',
        code:'HK',
        names:[
            {
                lang: Language.NL,
                value:'Hong-Kong'
            },
            {
                lang: Language.FR,
                value:'Hong-Kong'
            },
            {
                lang: Language.DE,
                value:'Hong-Kong'
            }
        ]
    },
    {
        name:'Hungary',
        dialCode:'+36',
        code:'HU',
        names:[
            {
                lang: Language.NL,
                value:'Hongarije'
            },
            {
                lang: Language.FR,
                value:'Hongrie'
            },
            {
                lang: Language.DE,
                value:'Ungarn'
            }
        ]
    },
    {
        name:'Iceland',
        dialCode:'+354',
        code:'IS',
        names:[
            {
                lang: Language.NL,
                value:'Ijsland'
            },
            {
                lang: Language.FR,
                value:'Islande'
            },
            {
                lang: Language.DE,
                value:'Island'
            }
        ]
    },
    {
        name:'India',
        dialCode:'+91',
        code:'IN',
        names:[
            {
                lang: Language.NL,
                value:'India'
            },
            {
                lang: Language.FR,
                value:'Inde'
            },
            {
                lang: Language.DE,
                value:'Indien'
            }
        ]
    },
    {
        name:'Indonesia',
        dialCode:'+62',
        code:'ID',
        names:[
            {
                lang: Language.NL,
                value:'Indonesië'
            },
            {
                lang: Language.FR,
                value:'Indonésie'
            },
            {
                lang: Language.DE,
                value:'Indonesien'
            }
        ]
    },
    {
        name:'Iran, Islamic Republic of Persian Gulf',
        dialCode:'+98',
        code:'IR',
        names:[
            {
                lang: Language.NL,
                value:'Iran'
            },
            {
                lang: Language.FR,
                value:'Iran'
            },
            {
                lang: Language.DE,
                value:'Iran'
            }
        ]
    },
    {
        name:'Iraq',
        dialCode:'+964',
        code:'IQ',
        names:[
            {
                lang: Language.NL,
                value:'Irak'
            },
            {
                lang: Language.FR,
                value:'Irak'
            },
            {
                lang: Language.DE,
                value:'Irak'
            }
        ]
    },
    {
        name:'Ireland',
        dialCode:'+353',
        code:'IE',
        names:[
            {
                lang: Language.NL,
                value:'Ierland'
            },
            {
                lang: Language.FR,
                value:'Irlande'
            },
            {
                lang: Language.DE,
                value:'Irland'
            }
        ]
    },
    {
        name:'Isle of Man',
        dialCode:'+44',
        code:'IM',
        names:[
            {
                lang: Language.NL,
                value:'Man Eiland'
            },
            {
                lang: Language.FR,
                value:'Île de Man'
            },
            {
                lang: Language.DE,
                value:'Isle of Man'
            }
        ]
    },
    {
        name:'Israel',
        dialCode:'+972',
        code:'IL',
        names:[
            {
                lang: Language.NL,
                value:'Israël'
            },
            {
                lang: Language.FR,
                value:'Israël'
            },
            {
                lang: Language.DE,
                value:'Israel'
            }
        ]
    },
    {
        name:'Italy',
        dialCode:'+39',
        code:'IT',
        names:[
            {
                lang: Language.NL,
                value:'Italië'
            },
            {
                lang: Language.FR,
                value:'Italie'
            },
            {
                lang: Language.DE,
                value:'Italien'
            }
        ]
    },
    {
        name:'Jamaica',
        dialCode:'+1876',
        code:'JM',
        names:[
            {
                lang: Language.NL,
                value:'Jamaica'
            },
            {
                lang: Language.FR,
                value:'Jamaïque'
            },
            {
                lang: Language.DE,
                value:'Jamaika'
            }
        ]
    },
    {
        name:'Japan',
        dialCode:'+81',
        code:'JP',
        names:[
            {
                lang: Language.NL,
                value:'Japan'
            },
            {
                lang: Language.FR,
                value:'Japon'
            },
            {
                lang: Language.DE,
                value:'Japan'
            }
        ]
    },
    {
        name:'Jersey',
        dialCode:'+44',
        code:'JE',
        names:[
            {
                lang: Language.NL,
                value:'Jersey'
            },
            {
                lang: Language.FR,
                value:'Jersey'
            },
            {
                lang: Language.DE,
                value:'Jersey'
            }
        ]
    },
    {
        name:'Jordan',
        dialCode:'+962',
        code:'JO',
        names:[
            {
                lang: Language.NL,
                value:'Jordanië'
            },
            {
                lang: Language.FR,
                value:'Jordanie'
            },
            {
                lang: Language.DE,
                value:'Jordanien'
            }
        ]
    },
    {
        name:'Kazakhstan',
        dialCode:'+77',
        code:'KZ',
        names:[
            {
                lang: Language.NL,
                value:'Kazachstan'
            },
            {
                lang: Language.FR,
                value:'Kazakhstan'
            },
            {
                lang: Language.DE,
                value:'Kasachstan'
            }
        ]
    },
    {
        name:'Kenya',
        dialCode:'+254',
        code:'KE',
        names:[
            {
                lang: Language.NL,
                value:'Kenya'
            },
            {
                lang: Language.FR,
                value:'Kenya'
            },
            {
                lang: Language.DE,
                value:'Kenia'
            }
        ]
    },
    {
        name:'Kiribati',
        dialCode:'+686',
        code:'KI',
        names:[
            {
                lang: Language.NL,
                value:'Kiribati'
            },
            {
                lang: Language.FR,
                value:'Kiribati'
            },
            {
                lang: Language.DE,
                value:'Kiribati'
            }
        ]
    },
    {
        name:'Korea, Democratic People\'s Republic of Korea',
        dialCode:'+850',
        code:'KP',
        names:[
            {
                lang: Language.NL,
                value:'Noord-Korea'
            },
            {
                lang: Language.FR,
                value:'Corée du Nord'
            },
            {
                lang: Language.DE,
                value:'Nordkorea'
            }
        ]
    },
    {
        name:'Korea, Republic of South Korea',
        dialCode:'+82',
        code:'KR',
        names:[
            {
                lang: Language.NL,
                value:'Zuid-Korea'
            },
            {
                lang: Language.FR,
                value:'Corée du Sud'
            },
            {
                lang: Language.DE,
                value:'Südkorea'
            }
        ]
    },
    {
        name:'Kuwait',
        dialCode:'+965',
        code:'KW',
        names:[
            {
                lang: Language.NL,
                value:'Koeweit'
            },
            {
                lang: Language.FR,
                value:'Koweit'
            },
            {
                lang: Language.DE,
                value:'Kuwait'
            }
        ]
    },
    {
        name:'Kyrgyzstan',
        dialCode:'+996',
        code:'KG',
        names:[
            {
                lang: Language.NL,
                value:'Kirgizstan'
            },
            {
                lang: Language.FR,
                value:'Kirghizie'
            },
            {
                lang: Language.DE,
                value:'Kirgistan'
            }
        ]
    },
    {
        name:'Laos',
        dialCode:'+856',
        code:'LA',
        names:[
            {
                lang: Language.NL,
                value:'Laos'
            },
            {
                lang: Language.FR,
                value:'Laos'
            },
            {
                lang: Language.DE,
                value:'Laos'
            }
        ]
    },
    {
        name:'Latvia',
        dialCode:'+371',
        code:'LV',
        names:[
            {
                lang: Language.NL,
                value:'Letland'
            },
            {
                lang: Language.FR,
                value:'Lettonie'
            },
            {
                lang: Language.DE,
                value:'Lettland'
            }
        ]
    },
    {
        name:'Lebanon',
        dialCode:'+961',
        code:'LB',
        names:[
            {
                lang: Language.NL,
                value:'Libanon'
            },
            {
                lang: Language.FR,
                value:'Liban'
            },
            {
                lang: Language.DE,
                value:'Libanon'
            }
        ]
    },
    {
        name:'Lesotho',
        dialCode:'+266',
        code:'LS',
        names:[
            {
                lang: Language.NL,
                value:'Lesotho'
            },
            {
                lang: Language.FR,
                value:'Lesotho'
            },
            {
                lang: Language.DE,
                value:'Lesotho'
            }
        ]
    },
    {
        name:'Liberia',
        dialCode:'+231',
        code:'LR',
        names:[
            {
                lang: Language.NL,
                value:'Liberia'
            },
            {
                lang: Language.FR,
                value:'Libéria'
            },
            {
                lang: Language.DE,
                value:'Liberia'
            }
        ]
    },
    {
        name:'Libyan Arab Jamahiriya',
        dialCode:'+218',
        code:'LY',
        names:[
            {
                lang: Language.NL,
                value:'Libië'
            },
            {
                lang: Language.FR,
                value:'Libye'
            },
            {
                lang: Language.DE,
                value:'Libyen'
            }
        ]
    },
    {
        name:'Liechtenstein',
        dialCode:'+423',
        code:'LI',
        names:[
            {
                lang: Language.NL,
                value:'Liechtenstein'
            },
            {
                lang: Language.FR,
                value:'Liechtenstein'
            },
            {
                lang: Language.DE,
                value:'Liechtenstein'
            }
        ]
    },
    {
        name:'Lithuania',
        dialCode:'+370',
        code:'LT',
        names:[
            {
                lang: Language.NL,
                value:'Litouwen'
            },
            {
                lang: Language.FR,
                value:'Lituanie'
            },
            {
                lang: Language.DE,
                value:'Litauen'
            }
        ]
    },
    {
        name:'Luxembourg',
        dialCode:'+352',
        code:'LU',
        names:[
            {
                lang: Language.NL,
                value:'Luxemburg'
            },
            {
                lang: Language.FR,
                value:'Luxembourg'
            },
            {
                lang: Language.DE,
                value:'Luxemburg'
            }
        ]
    },
    {
        name:'Macao',
        dialCode:'+853',
        code:'MO',
        names:[
            {
                lang: Language.NL,
                value:'Macau'
            },
            {
                lang: Language.FR,
                value:'Macao'
            },
            {
                lang: Language.DE,
                value:'Macau'
            }
        ]
    },
    {
        name:'Macedonia',
        dialCode:'+389',
        code:'MK',
        names:[
            {
                lang: Language.NL,
                value:'Noord-Macedonië'
            },
            {
                lang: Language.FR,
                value:'Macédoine du Nord'
            },
            {
                lang: Language.DE,
                value:'Nordmazedonien'
            }
        ]
    },
    {
        name:'Madagascar',
        dialCode:'+261',
        code:'MG',
        names:[
            {
                lang: Language.NL,
                value:'Madagascar'
            },
            {
                lang: Language.FR,
                value:'Madagascar'
            },
            {
                lang: Language.DE,
                value:'Madagaskar'
            }
        ]
    },
    {
        name:'Malawi',
        dialCode:'+265',
        code:'MW',
        names:[
            {
                lang: Language.NL,
                value:'Malawi'
            },
            {
                lang: Language.FR,
                value:'Malawi'
            },
            {
                lang: Language.DE,
                value:'Malawi'
            }
        ]
    },
    {
        name:'Malaysia',
        dialCode:'+60',
        code:'MY',
        names:[
            {
                lang: Language.NL,
                value:'Maleisië'
            },
            {
                lang: Language.FR,
                value:'Malaisie'
            },
            {
                lang: Language.DE,
                value:'Malaya'
            }
        ]
    },
    {
        name:'Maldives',
        dialCode:'+960',
        code:'MV',
        names:[
            {
                lang: Language.NL,
                value:'Maldiven'
            },
            {
                lang: Language.FR,
                value:'Maldives'
            },
            {
                lang: Language.DE,
                value:'Malediven'
            }
        ]
    },
    {
        name:'Mali',
        dialCode:'+223',
        code:'ML',
        names:[
            {
                lang: Language.NL,
                value:'Mali'
            },
            {
                lang: Language.FR,
                value:'Mali'
            },
            {
                lang: Language.DE,
                value:'Mali'
            }
        ]
    },
    {
        name:'Malta',
        dialCode:'+356',
        code:'MT',
        names:[
            {
                lang: Language.NL,
                value:'Malta'
            },
            {
                lang: Language.FR,
                value:'Malte'
            },
            {
                lang: Language.DE,
                value:'Malta'
            }
        ]
    },
    {
        name:'Marshall Islands',
        dialCode:'+692',
        code:'MH',
        names:[
            {
                lang: Language.NL,
                value:'Marshalleilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Marshall'
            },
            {
                lang: Language.DE,
                value:'Marshallinseln'
            }
        ]
    },
    {
        name:'Martinique',
        dialCode:'+596',
        code:'MQ',
        names:[
            {
                lang: Language.NL,
                value:'Martinique'
            },
            {
                lang: Language.FR,
                value:'Martinique'
            },
            {
                lang: Language.DE,
                value:'Martinique'
            }
        ]
    },
    {
        name:'Mauritania',
        dialCode:'+222',
        code:'MR',
        names:[
            {
                lang: Language.NL,
                value:'Mauritanië'
            },
            {
                lang: Language.FR,
                value:'Mauritanie'
            },
            {
                lang: Language.DE,
                value:'Mauretanien'
            }
        ]
    },
    {
        name:'Mauritius',
        dialCode:'+230',
        code:'MU',
        names:[
            {
                lang: Language.NL,
                value:'Mauritius Eiland'
            },
            {
                lang: Language.FR,
                value:'Ile Maurice'
            },
            {
                lang: Language.DE,
                value:'Mauritius Insel'
            }
        ]
    },
    {
        name:'Mayotte',
        dialCode:'+262',
        code:'YT',
        names:[
            {
                lang: Language.NL,
                value:'Mayotte'
            },
            {
                lang: Language.FR,
                value:'Mayotte'
            },
            {
                lang: Language.DE,
                value:'Mayotte'
            }
        ]
    },
    {
        name:'Mexico',
        dialCode:'+52',
        code:'MX',
        names:[
            {
                lang: Language.NL,
                value:'Mexico'
            },
            {
                lang: Language.FR,
                value:'Mexique'
            },
            {
                lang: Language.DE,
                value:'Mexiko'
            }
        ]
    },
    {
        name:'Micronesia, Federated States of Micronesia',
        dialCode:'+691',
        code:'FM',
        names:[
            {
                lang: Language.NL,
                value:'Micronesia'
            },
            {
                lang: Language.FR,
                value:'Micronesia'
            },
            {
                lang: Language.DE,
                value:'Micronesia'
            }
        ]
    },
    {
        name:'Moldova',
        dialCode:'+373',
        code:'MD',
        names:[
            {
                lang: Language.NL,
                value:'Moldavië'
            },
            {
                lang: Language.FR,
                value:'Moldavie'
            },
            {
                lang: Language.DE,
                value:'Moldawien'
            }
        ]
    },
    {
        name:'Monaco',
        dialCode:'+377',
        code:'MC',
        names:[
            {
                lang: Language.NL,
                value:'Monaco'
            },
            {
                lang: Language.FR,
                value:'Monaco'
            },
            {
                lang: Language.DE,
                value:'Monako'
            }
        ]
    },
    {
        name:'Mongolia',
        dialCode:'+976',
        code:'MN',
        names:[
            {
                lang: Language.NL,
                value:'Mongolië'
            },
            {
                lang: Language.FR,
                value:'Mongolie'
            },
            {
                lang: Language.DE,
                value:'Mongolei'
            }
        ]
    },
    {
        name:'Montenegro',
        dialCode:'+382',
        code:'ME',
        names:[
            {
                lang: Language.NL,
                value:'Montenegro'
            },
            {
                lang: Language.FR,
                value:'Monténégro'
            },
            {
                lang: Language.DE,
                value:'Monténégro'
            }
        ]
    },
    {
        name:'Montserrat',
        dialCode:'+1664',
        code:'MS',
        names:[
            {
                lang: Language.NL,
                value:'Montserrat'
            },
            {
                lang: Language.FR,
                value:'Montserrat'
            },
            {
                lang: Language.DE,
                value:'Montserrat'
            }
        ]
    },
    {
        name:'Morocco',
        dialCode:'+212',
        code:'MA',
        names:[
            {
                lang: Language.NL,
                value:'Marokko'
            },
            {
                lang: Language.FR,
                value:'Maroc'
            },
            {
                lang: Language.DE,
                value:'Marokko'
            }
        ]
    },
    {
        name:'Mozambique',
        dialCode:'+258',
        code:'MZ',
        names:[
            {
                lang: Language.NL,
                value:'Mozambique'
            },
            {
                lang: Language.FR,
                value:'Mozambique'
            },
            {
                lang: Language.DE,
                value:'Mosambik'
            }
        ]
    },
    {
        name:'Myanmar',
        dialCode:'+95',
        code:'MM',
        names:[
            {
                lang: Language.NL,
                value:'Myanmar'
            },
            {
                lang: Language.FR,
                value:'Myanmar'
            },
            {
                lang: Language.DE,
                value:'Myanmar'
            }
        ]
    },
    {
        name:'Namibia',
        dialCode:'+264',
        code:'NA',
        names:[
            {
                lang: Language.NL,
                value:'Namibie'
            },
            {
                lang: Language.FR,
                value:'Namibie'
            },
            {
                lang: Language.DE,
                value:'Namibia'
            }
        ]
    },
    {
        name:'Nauru',
        dialCode:'+674',
        code:'NR',
        names:[
            {
                lang: Language.NL,
                value:'Nauru'
            },
            {
                lang: Language.FR,
                value:'Nauru'
            },
            {
                lang: Language.DE,
                value:'Nauru'
            }
        ]
    },
    {
        name:'Nepal',
        dialCode:'+977',
        code:'NP',
        names:[
            {
                lang: Language.NL,
                value:'Nepal'
            },
            {
                lang: Language.FR,
                value:'Népal'
            },
            {
                lang: Language.DE,
                value:'Nepal'
            }
        ]
    },
    {
        name:'Netherlands',
        dialCode:'+31',
        code:'NL',
        names:[
            {
                lang: Language.NL,
                value:'Nederland'
            },
            {
                lang: Language.FR,
                value:'Pays-Bas'
            },
            {
                lang: Language.DE,
                value:'Niederlande'
            }
        ]
    },
    {
        name:'New Caledonia',
        dialCode:'+687',
        code:'NC',
        names:[
            {
                lang: Language.NL,
                value:'Nieuw-Caledonië'
            },
            {
                lang: Language.FR,
                value:'Nouvelle-Calédonie'
            },
            {
                lang: Language.DE,
                value:'Neukaledonien'
            }
        ]
    },
    {
        name:'New Zealand',
        dialCode:'+64',
        code:'NZ',
        names:[
            {
                lang: Language.NL,
                value:'Nieuw-Zeeland'
            },
            {
                lang: Language.FR,
                value:'Nouvelle-Zélande'
            },
            {
                lang: Language.DE,
                value:'Neuseeland'
            }
        ]
    },
    {
        name:'Nicaragua',
        dialCode:'+505',
        code:'NI',
        names:[
            {
                lang: Language.NL,
                value:'Nicaragua'
            },
            {
                lang: Language.FR,
                value:'Nicaragua'
            },
            {
                lang: Language.DE,
                value:'Nicaragua'
            }
        ]
    },
    {
        name:'Niger',
        dialCode:'+227',
        code:'NE',
        names:[
            {
                lang: Language.NL,
                value:'Niger'
            },
            {
                lang: Language.FR,
                value:'Niger'
            },
            {
                lang: Language.DE,
                value:'Niger'
            }
        ]
    },
    {
        name:'Nigeria',
        dialCode:'+234',
        code:'NG',
        names:[
            {
                lang: Language.NL,
                value:'Nigeria'
            },
            {
                lang: Language.FR,
                value:'Nigéria'
            },
            {
                lang: Language.DE,
                value:'Nigeria'
            }
        ]
    },
    {
        name:'Niue',
        dialCode:'+683',
        code:'NU',
        names:[
            {
                lang: Language.NL,
                value:'Niue'
            },
            {
                lang: Language.FR,
                value:'Niue'
            },
            {
                lang: Language.DE,
                value:'Niue'
            }
        ]
    },
    {
        name:'Norfolk Island',
        dialCode:'+672',
        code:'NF',
        names:[
            {
                lang: Language.NL,
                value:'Niue'
            },
            {
                lang: Language.FR,
                value:'Île Norfolk'
            },
            {
                lang: Language.DE,
                value:'Norfolkinsel'
            }
        ]
    },
    {
        name:'Northern Mariana Islands',
        dialCode:'+1670',
        code:'MP',
        names:[
            {
                lang: Language.NL,
                value:'Noordelijke Marianen'
            },
            {
                lang: Language.FR,
                value:'Îles Mariannes du Nord'
            },
            {
                lang: Language.DE,
                value:'Nördliche Marianen'
            }
        ]
    },
    {
        name:'Norway',
        dialCode:'+47',
        code:'NO',
        names:[
            {
                lang: Language.NL,
                value:'Noorwegen'
            },
            {
                lang: Language.FR,
                value:'Norvège'
            },
            {
                lang: Language.DE,
                value:'Norwegen'
            }
        ]
    },
    {
        name:'Oman',
        dialCode:'+968',
        code:'OM',
        names:[
            {
                lang: Language.NL,
                value:'Oman'
            },
            {
                lang: Language.FR,
                value:'Oman'
            },
            {
                lang: Language.DE,
                value:'Oman'
            }
        ]
    },
    {
        name:'Pakistan',
        dialCode:'+92',
        code:'PK',
        names:[
            {
                lang: Language.NL,
                value:'Pakistan'
            },
            {
                lang: Language.FR,
                value:'Pakistan'
            },
            {
                lang: Language.DE,
                value:'Pakistan'
            }
        ]
    },
    {
        name:'Palau',
        dialCode:'+680',
        code:'PW',
        names:[
            {
                lang: Language.NL,
                value:'Palau'
            },
            {
                lang: Language.FR,
                value:'Palau'
            },
            {
                lang: Language.DE,
                value:'Palau'
            }
        ]
    },
    {
        name:'Palestinian Territory, Occupied',
        dialCode:'+970',
        code:'PS',
        names:[
            {
                lang: Language.NL,
                value:'Palestina'
            },
            {
                lang: Language.FR,
                value:'Palestine'
            },
            {
                lang: Language.DE,
                value:'Palästina'
            }
        ]
    },
    {
        name:'Panama',
        dialCode:'+507',
        code:'PA',
        names:[
            {
                lang: Language.NL,
                value:'Panama'
            },
            {
                lang: Language.FR,
                value:'Panama'
            },
            {
                lang: Language.DE,
                value:'Panama'
            }
        ]
    },
    {
        name:'Papua New Guinea',
        dialCode:'+675',
        code:'PG',
        names:[
            {
                lang: Language.NL,
                value:'Nieuw-Guinea-Papoua'
            },
            {
                lang: Language.FR,
                value:'Papouasie-Nouvelle-Guinée'
            },
            {
                lang: Language.DE,
                value:'Neu-Guinea-Papua'
            }
        ]
    },
    {
        name:'Paraguay',
        dialCode:'+595',
        code:'PY',
        names:[
            {
                lang: Language.NL,
                value:'Paraguay'
            },
            {
                lang: Language.FR,
                value:'Paraguay'
            },
            {
                lang: Language.DE,
                value:'Paraguay'
            }
        ]
    },
    {
        name:'Peru',
        dialCode:'+51',
        code:'PE',
        names:[
            {
                lang: Language.NL,
                value:'Peru'
            },
            {
                lang: Language.FR,
                value:'Pérou'
            },
            {
                lang: Language.DE,
                value:'Peru'
            }
        ]
    },
    {
        name:'Philippines',
        dialCode:'+63',
        code:'PH',
        names:[
            {
                lang: Language.NL,
                value:'Filippijnen'
            },
            {
                lang: Language.FR,
                value:'Philippines'
            },
            {
                lang: Language.DE,
                value:'Philippinen'
            }
        ]
    },
    {
        name:'Poland',
        dialCode:'+48',
        code:'PL',
        names:[
            {
                lang: Language.NL,
                value:'Polen'
            },
            {
                lang: Language.FR,
                value:'Pologne'
            },
            {
                lang: Language.DE,
                value:'Polen'
            }
        ]
    },
    {
        name:'Portugal',
        dialCode:'+351',
        code:'PT',
        names:[
            {
                lang: Language.NL,
                value:'Portugal'
            },
            {
                lang: Language.FR,
                value:'Portugal'
            },
            {
                lang: Language.DE,
                value:'Portugal'
            }
        ]
    },
    {
        name:'Puerto Rico',
        dialCode:'+1939',
        code:'PR',
        names:[
            {
                lang: Language.NL,
                value:'Porto Rico'
            },
            {
                lang: Language.FR,
                value:'Porto-Rico'
            },
            {
                lang: Language.DE,
                value:'Portoriko'
            }
        ]
    },
    {
        name:'Qatar',
        dialCode:'+974',
        code:'QA',
        names:[
            {
                lang: Language.NL,
                value:'Qatar'
            },
            {
                lang: Language.FR,
                value:'Qatar'
            },
            {
                lang: Language.DE,
                value:'Qatar'
            }
        ]
    },
    {
        name:'Romania',
        dialCode:'+40',
        code:'RO',
        names:[
            {
                lang: Language.NL,
                value:'Roemenië'
            },
            {
                lang: Language.FR,
                value:'Roumanie'
            },
            {
                lang: Language.DE,
                value:'Rumänien'
            }
        ]
    },
    {
        name:'Russia',
        dialCode:'+7',
        code:'RU',
        names:[
            {
                lang: Language.NL,
                value:'Rusland'
            },
            {
                lang: Language.FR,
                value:'Russie'
            },
            {
                lang: Language.DE,
                value:'Russland'
            }
        ]
    },
    {
        name:'Rwanda',
        dialCode:'+250',
        code:'RW',
        names:[
            {
                lang: Language.NL,
                value:'Rwanda'
            },
            {
                lang: Language.FR,
                value:'Rwanda'
            },
            {
                lang: Language.DE,
                value:'Ruanda'
            }
        ]
    },
    {
        name:'Reunion',
        dialCode:'+262',
        code:'RE',
        names:[
            {
                lang: Language.NL,
                value:'Réunion'
            },
            {
                lang: Language.FR,
                value:'Réunion'
            },
            {
                lang: Language.DE,
                value:'Réunion'
            }
        ]
    },
    {
        name:'Saint Barthelemy',
        dialCode:'+590',
        code:'BL',
        names:[
            {
                lang: Language.NL,
                value:'Saint-Barthélemy'
            },
            {
                lang: Language.FR,
                value:'Saint-Barthélemy'
            },
            {
                lang: Language.DE,
                value:'Saint-Barthélemy'
            }
        ]
    },
    {
        name:'Saint Helena, Ascension and Tristan Da Cunha',
        dialCode:'+290',
        code:'SH',
        names:[
            {
                lang: Language.NL,
                value:'Sint-Helena'
            },
            {
                lang: Language.FR,
                value:'Sainte-Hélène'
            },
            {
                lang: Language.DE,
                value:'Sankt-Helena'
            }
        ]
    },
    {
        name:'Saint Kitts and Nevis',
        dialCode:'+1869',
        code:'KN',
        names:[
            {
                lang: Language.NL,
                value:'St. Kitts en Nevis'
            },
            {
                lang: Language.FR,
                value:'St. Kitts et Nevis'
            },
            {
                lang: Language.DE,
                value:'St. Kitts und Nevis'
            }
        ]
    },
    {
        name:'Saint Lucia',
        dialCode:'+1758',
        code:'LC',
        names:[
            {
                lang: Language.NL,
                value:'Sint-Lucia'
            },
            {
                lang: Language.FR,
                value:'Sainte Lucie'
            },
            {
                lang: Language.DE,
                value:'Sankt-Luzia'
            }
        ]
    },
    {
        name:'Saint Martin',
        dialCode:'+590',
        code:'MF',
        names:[
            {
                lang: Language.NL,
                value:'Sint Maarten'
            },
            {
                lang: Language.FR,
                value:'Saint-Martin'
            },
            {
                lang: Language.DE,
                value:'St. Martin'
            }
        ]
    },
    {
        name:'Saint Pierre and Miquelon',
        dialCode:'+508',
        code:'PM',
        names:[
            {
                lang: Language.NL,
                value:'Saint-Pierre et Miquelon'
            },
            {
                lang: Language.FR,
                value:'Saint-Pierre et Miquelon'
            },
            {
                lang: Language.DE,
                value:'Saint-Pierre et Miquelon'
            }
        ]
    },
    {
        name:'Saint Vincent and the Grenadines',
        dialCode:'+1784',
        code:'VC',
        names:[
            {
                lang: Language.NL,
                value:'Saint Vincent'
            },
            {
                lang: Language.FR,
                value:'Saint-Vincent'
            },
            {
                lang: Language.DE,
                value:'Saint Vincent'
            }
        ]
    },
    {
        name:'Samoa',
        dialCode:'+685',
        code:'WS',
        names:[
            {
                lang: Language.NL,
                value:'Samoa'
            },
            {
                lang: Language.FR,
                value:'Samoa'
            },
            {
                lang: Language.DE,
                value:'Samoa'
            }
        ]
    },
    {
        name:'San Marino',
        dialCode:'+378',
        code:'SM',
        names:[
            {
                lang: Language.NL,
                value:'San Marino'
            },
            {
                lang: Language.FR,
                value:'Saint-Marin'
            },
            {
                lang: Language.DE,
                value:'San Marino'
            }
        ]
    },
    {
        name:'Sao Tome and Principe',
        dialCode:'+239',
        code:'ST',
        names:[
            {
                lang: Language.NL,
                value:'Sao Tomé en Principe'
            },
            {
                lang: Language.FR,
                value:'Sao Tomé et Principe'
            },
            {
                lang: Language.DE,
                value:'Sao Tomé und Principe'
            }
        ]
    },
    {
        name:'Saudi Arabia',
        dialCode:'+966',
        code:'SA',
        names:[
            {
                lang: Language.NL,
                value:'Saoedi-Arabië'
            },
            {
                lang: Language.FR,
                value:'Arabie Saoudite'
            },
            {
                lang: Language.DE,
                value:'Saudi-Arabien'
            }
        ]
    },
    {
        name:'Senegal',
        dialCode:'+221',
        code:'SN',
        names:[
            {
                lang: Language.NL,
                value:'Senegal'
            },
            {
                lang: Language.FR,
                value:'Sénégal'
            },
            {
                lang: Language.DE,
                value:'Senegal'
            }
        ]
    },
    {
        name:'Serbia',
        dialCode:'+381',
        code:'RS',
        names:[
            {
                lang: Language.NL,
                value:'Servië'
            },
            {
                lang: Language.FR,
                value:'Serbie'
            },
            {
                lang: Language.DE,
                value:'Serbie'
            }
        ]
    },
    {
        name:'Seychelles',
        dialCode:'+248',
        code:'SC',
        names:[
            {
                lang: Language.NL,
                value:'Seychellen'
            },
            {
                lang: Language.FR,
                value:'Seychelles'
            },
            {
                lang: Language.DE,
                value:'Seychellen'
            }
        ]
    },
    {
        name:'Sierra Leone',
        dialCode:'+232',
        code:'SL',
        names:[
            {
                lang: Language.NL,
                value:'Sierra Leone'
            },
            {
                lang: Language.FR,
                value:'Sierra Leone'
            },
            {
                lang: Language.DE,
                value:'Sierra Leone'
            }
        ]
    },
    {
        name:'Singapore',
        dialCode:'+65',
        code:'SG',
        names:[
            {
                lang: Language.NL,
                value:'Singapore'
            },
            {
                lang: Language.FR,
                value:'Singapour'
            },
            {
                lang: Language.DE,
                value:'Singapur'
            }
        ]
    },
    {
        name:'Slovakia',
        dialCode:'+421',
        code:'SK',
        names:[
            {
                lang: Language.NL,
                value:'Slovaakse Republiek'
            },
            {
                lang: Language.FR,
                value:'République Slovaque'
            },
            {
                lang: Language.DE,
                value:'Slowakische Republik'
            }
        ]
    },
    {
        name:'Slovenia',
        dialCode:'+386',
        code:'SI',
        names:[
            {
                lang: Language.NL,
                value:'Slovenië'
            },
            {
                lang: Language.FR,
                value:'Slovénie'
            },
            {
                lang: Language.DE,
                value:'Slowenien'
            }
        ]
    },
    {
        name:'Solomon Islands',
        dialCode:'+677',
        code:'SB',
        names:[
            {
                lang: Language.NL,
                value:'Salomoneilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Salomon'
            },
            {
                lang: Language.DE,
                value:'Salomoninseln'
            }
        ]
    },
    {
        name:'Somalia',
        dialCode:'+252',
        code:'SO',
        names:[
            {
                lang: Language.NL,
                value:'Somalië'
            },
            {
                lang: Language.FR,
                value:'Somalie'
            },
            {
                lang: Language.DE,
                value:'Somaliland Rep.'
            }
        ]
    },
    {
        name:'South Africa',
        dialCode:'+27',
        code:'ZA',
        names:[
            {
                lang: Language.NL,
                value:'Zuid-Afrika'
            },
            {
                lang: Language.FR,
                value:'Afrique du Sud'
            },
            {
                lang: Language.DE,
                value:'Sudafrikanische Republik'
            }
        ]
    },
    {
        name:'South Sudan',
        dialCode:'+211',
        code:'SS',
        names:[
            {
                lang: Language.NL,
                value:'Zuid-Soedan'
            },
            {
                lang: Language.FR,
                value:'Soudan du Sud'
            },
            {
                lang: Language.DE,
                value:'Südsudan'
            }
        ]
    },
    {
        name:'Spain',
        dialCode:'+34',
        code:'ES',
        names:[
            {
                lang: Language.NL,
                value:'Spanje'
            },
            {
                lang: Language.FR,
                value:'Espagne'
            },
            {
                lang: Language.DE,
                value:'Spanien'
            }
        ]
    },
    {
        name:'Sri Lanka',
        dialCode:'+94',
        code:'LK',
        names:[
            {
                lang: Language.NL,
                value:'Sri Lanka'
            },
            {
                lang: Language.FR,
                value:'Sri Lanka'
            },
            {
                lang: Language.DE,
                value:'Sri Lanka'
            }
        ]
    },
    {
        name:'Sudan',
        dialCode:'+249',
        code:'SD',
        names:[
            {
                lang: Language.NL,
                value:'Soedan'
            },
            {
                lang: Language.FR,
                value:'Soudan'
            },
            {
                lang: Language.DE,
                value:'Sudan'
            }
        ]
    },
    {
        name:'Suriname',
        dialCode:'+597',
        code:'SR',
        names:[
            {
                lang: Language.NL,
                value:'Suriname'
            },
            {
                lang: Language.FR,
                value:'Surinam'
            },
            {
                lang: Language.DE,
                value:'Surinam'
            }
        ]
    },
    {
        name:'Svalbard and Jan Mayen',
        dialCode:'+47',
        code:'SJ',
        names:[
            {
                lang: Language.NL,
                value:'Spitsbergen en Jan Mayen'
            },
            {
                lang: Language.FR,
                value:'Svalbard et Jan Mayen'
            },
            {
                lang: Language.DE,
                value:'Spitzbergen und Jan Mayen'
            }
        ]
    },
    {
        name:'Swaziland',
        dialCode:'+268',
        code:'SZ',
        names:[
            {
                lang: Language.NL,
                value:'Swaziland'
            },
            {
                lang: Language.FR,
                value:'Swaziland'
            },
            {
                lang: Language.DE,
                value:'Swaziland'
            }
        ]
    },
    {
        name:'Sweden',
        dialCode:'+46',
        code:'SE',
        names:[
            {
                lang: Language.NL,
                value:'Zweden'
            },
            {
                lang: Language.FR,
                value:'Suède'
            },
            {
                lang: Language.DE,
                value:'Schweden'
            }
        ]
    },
    {
        name:'Switzerland',
        dialCode:'+41',
        code:'CH',
        names:[
            {
                lang: Language.NL,
                value:'Zwitserland'
            },
            {
                lang: Language.FR,
                value:'Suisse'
            },
            {
                lang: Language.DE,
                value:'Schweiz'
            }
        ]
    },
    {
        name:'Syrian Arab Republic',
        dialCode:'+963',
        code:'SY',
        names:[
            {
                lang: Language.NL,
                value:'Syrië'
            },
            {
                lang: Language.FR,
                value:'Syrie'
            },
            {
                lang: Language.DE,
                value:'Syrien'
            }
        ]
    },
    {
        name:'Taiwan',
        dialCode:'+886',
        code:'TW',
        names:[
            {
                lang: Language.NL,
                value:'China-Taïwan'
            },
            {
                lang: Language.FR,
                value:'Chine-Taïwan'
            },
            {
                lang: Language.DE,
                value:'China-Taïwan'
            }
        ]
    },
    {
        name:'Tajikistan',
        dialCode:'+992',
        code:'TJ',
        names:[
            {
                lang: Language.NL,
                value:'Tadzjikistan'
            },
            {
                lang: Language.FR,
                value:'Tadjikistan'
            },
            {
                lang: Language.DE,
                value:'Tadschikistan'
            }
        ]
    },
    {
        name:'Tanzania, United Republic of Tanzania',
        dialCode:'+255',
        code:'TZ',
        names:[
            {
                lang: Language.NL,
                value:'Tanzania'
            },
            {
                lang: Language.FR,
                value:'Tanzanie'
            },
            {
                lang: Language.DE,
                value:'Tansania'
            }
        ]
    },
    {
        name:'Thailand',
        dialCode:'+66',
        code:'TH',
        names:[
            {
                lang: Language.NL,
                value:'Thailand'
            },
            {
                lang: Language.FR,
                value:'Thaïlande'
            },
            {
                lang: Language.DE,
                value:'Thailand'
            }
        ]
    },
    {
        name:'Timor-Leste',
        dialCode:'+670',
        code:'TL',
        names:[
            {
                lang: Language.NL,
                value:'Oost-Timor'
            },
            {
                lang: Language.FR,
                value:'Timor-Leste'
            },
            {
                lang: Language.DE,
                value:'Timor-Leste'
            }
        ]
    },
    {
        name:'Togo',
        dialCode:'+228',
        code:'TG',
        names:[
            {
                lang: Language.NL,
                value:'Togo'
            },
            {
                lang: Language.FR,
                value:'Togo'
            },
            {
                lang: Language.DE,
                value:'Togo'
            }
        ]
    },
    {
        name:'Tokelau',
        dialCode:'+690',
        code:'TK',
        names:[
            {
                lang: Language.NL,
                value:'Tokelau'
            },
            {
                lang: Language.FR,
                value:'Tokelau'
            },
            {
                lang: Language.DE,
                value:'Tokelau'
            }
        ]
    },
    {
        name:'Tonga',
        dialCode:'+676',
        code:'TO',
        names:[
            {
                lang: Language.NL,
                value:'Tonga'
            },
            {
                lang: Language.FR,
                value:'Tonga'
            },
            {
                lang: Language.DE,
                value:'Tonga'
            }
        ]
    },
    {
        name:'Trinidad and Tobago',
        dialCode:'+1868',
        code:'TT',
        names:[
            {
                lang: Language.NL,
                value:'Trinidad en Tobago'
            },
            {
                lang: Language.FR,
                value:'Trinidad et Tobago'
            },
            {
                lang: Language.DE,
                value:'Trinidad und Tobago'
            }
        ]
    },
    {
        name:'Tunisia',
        dialCode:'+216',
        code:'TN',
        names:[
            {
                lang: Language.NL,
                value:'Tunesië'
            },
            {
                lang: Language.FR,
                value:'Tunisie'
            },
            {
                lang: Language.DE,
                value:'Tunesien'
            }
        ]
    },
    {
        name:'Turkey',
        dialCode:'+90',
        code:'TR',
        names:[
            {
                lang: Language.NL,
                value:'Turkije'
            },
            {
                lang: Language.FR,
                value:'Turquie'
            },
            {
                lang: Language.DE,
                value:'Türkei'
            }
        ]
    },
    {
        name:'Turkmenistan',
        dialCode:'+993',
        code:'TM',
        names:[
            {
                lang: Language.NL,
                value:'Turkmenistan'
            },
            {
                lang: Language.FR,
                value:'Turkménistan'
            },
            {
                lang: Language.DE,
                value:'Turkmenistan'
            }
        ]
    },
    {
        name:'Turks and Caicos Islands',
        dialCode:'+1649',
        code:'TC',
        names:[
            {
                lang: Language.NL,
                value:'Turks en Caicos Eilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Turks et Caicos'
            },
            {
                lang: Language.DE,
                value:'Turks und Caicos Inseln'
            }
        ]
    },
    {
        name:'Tuvalu',
        dialCode:'+688',
        code:'TV',
        names:[
            {
                lang: Language.NL,
                value:'Tuvalu'
            },
            {
                lang: Language.FR,
                value:'Tuvalu'
            },
            {
                lang: Language.DE,
                value:'Tuvalu'
            }
        ]
    },
    {
        name:'Uganda',
        dialCode:'+256',
        code:'UG',
        names:[
            {
                lang: Language.NL,
                value:'Uganda'
            },
            {
                lang: Language.FR,
                value:'Ouganda'
            },
            {
                lang: Language.DE,
                value:'Uganda'
            }
        ]
    },
    {
        name:'Ukraine',
        dialCode:'+380',
        code:'UA',
        names:[
            {
                lang: Language.NL,
                value:'Oekraïne'
            },
            {
                lang: Language.FR,
                value:'Ukraine'
            },
            {
                lang: Language.DE,
                value:'Ukraine'
            }
        ]
    },
    {
        name:'United Arab Emirates',
        dialCode:'+971',
        code:'AE',
        names:[
            {
                lang: Language.NL,
                value:'Verenigde Arabische Emiraten'
            },
            {
                lang: Language.FR,
                value:'Emirats arabes unis'
            },
            {
                lang: Language.DE,
                value:'Vereinigten Arabischen Emiraten'
            }
        ]
    },
    {
        name:'United Kingdom',
        dialCode:'+44',
        code:'GB',
        names:[
            {
                lang: Language.NL,
                value:'Groot-Brittannië'
            },
            {
                lang: Language.FR,
                value:'Grande-Bretagne'
            },
            {
                lang: Language.DE,
                value:'Grossbritannien'
            }
        ]
    },
    {
        name:'United States',
        dialCode:'+1',
        code:'US',
        names:[
            {
                lang: Language.NL,
                value:'Verenigde Staten van Amerika'
            },
            {
                lang: Language.FR,
                value:'Etats-Unis d\'Amérique'
            },
            {
                lang: Language.DE,
                value:'Vereinigten Staaten von Amerika'
            }
        ]
    },
    {
        name:'Uruguay',
        dialCode:'+598',
        code:'UY',
        names:[
            {
                lang: Language.NL,
                value:'Uruguay'
            },
            {
                lang: Language.FR,
                value:'Uruguay'
            },
            {
                lang: Language.DE,
                value:'Uruguay'
            }
        ]
    },
    {
        name:'Uzbekistan',
        dialCode:'+998',
        code:'UZ',
        names:[
            {
                lang: Language.NL,
                value:'Oezbekistan'
            },
            {
                lang: Language.FR,
                value:'Ouzbékistan'
            },
            {
                lang: Language.DE,
                value:'Uzbekistan'
            }
        ]
    },
    {
        name:'Vanuatu',
        dialCode:'+678',
        code:'VU',
        names:[
            {
                lang: Language.NL,
                value:'Vanuatu'
            },
            {
                lang: Language.FR,
                value:'Vanuatu'
            },
            {
                lang: Language.DE,
                value:'Vanuatu'
            }
        ]
    },
    {
        name:'Venezuela, Bolivarian Republic of Venezuela',
        dialCode:'+58',
        code:'VE',
        names:[
            {
                lang: Language.NL,
                value:'Venezuela'
            },
            {
                lang: Language.FR,
                value:'Vénézuéla'
            },
            {
                lang: Language.DE,
                value:'Venezuela'
            }
        ]
    },
    {
        name:'Vietnam',
        dialCode:'+84',
        code:'VN',
        names:[
            {
                lang: Language.NL,
                value:'Vietnam'
            },
            {
                lang: Language.FR,
                value:'Vietnam'
            },
            {
                lang: Language.DE,
                value:'Vietnam'
            }
        ]
    },
    {
        name:'Virgin Islands, British',
        dialCode:'+1284',
        code:'VG',
        names:[
            {
                lang: Language.NL,
                value:'Britse Maagdeneilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Vierges britanniques'
            },
            {
                lang: Language.DE,
                value:'Britische Jungferninseln'
            }
        ]
    },
    {
        name:'Virgin Islands, U.S.',
        dialCode:'+1340',
        code:'VI',
        names:[
            {
                lang: Language.NL,
                value:'Amerikaanse Maagdeneilanden'
            },
            {
                lang: Language.FR,
                value:'Iles Vierges américaines'
            },
            {
                lang: Language.DE,
                value:'Amerikanische Jungferninseln'
            }
        ]
    },
    {
        name:'Wallis and Futuna',
        dialCode:'+681',
        code:'WF',
        names:[
            {
                lang: Language.NL,
                value:'Wallis en Futuna'
            },
            {
                lang: Language.FR,
                value:'Wallis et Futuna'
            },
            {
                lang: Language.DE,
                value:'Wallis und Futuna'
            }
        ]
    },
    {
        name:'Yemen',
        dialCode:'+967',
        code:'YE',
        names:[
            {
                lang: Language.NL,
                value:'Jemen'
            },
            {
                lang: Language.FR,
                value:'Yemen'
            },
            {
                lang: Language.DE,
                value:'Jemen'
            }
        ]
    },
    {
        name:'Zambia',
        dialCode:'+260',
        code:'ZM',
        names:[
            {
                lang: Language.NL,
                value:'Zambia'
            },
            {
                lang: Language.FR,
                value:'Zambie'
            },
            {
                lang: Language.DE,
                value:'Sambia'
            }
        ]
    },
    {
        name:'Zimbabwe',
        dialCode:'+263',
        code:'ZW',
        names:[
            {
                lang: Language.NL,
                value:'Zimbabwe'
            },
            {
                lang: Language.FR,
                value:'Zimbabwe'
            },
            {
                lang: Language.DE,
                value:'Zimbabwe'
            }
        ]
    }
];
